import React from 'react';
import { useLocation } from "react-router-dom";
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import { useFrontContext } from "v4/contexts/FrontContext";
import { SearchProvider } from "v4/contexts/SearchContext/SearchContext";
import { PROSPECT_SEARCH } from "v4/data/apiRoutes";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import useHashPulse from "v4/hooks/useHashPulse";
import ProspectsAdd from "v4/pages/front/Prospects/components/ProspectsAdd/ProspectsAdd";
import ProspectsListing from "v4/pages/front/Prospects/components/ProspectsListing/ProspectsListing";
import CustomerCodeProspectLoader from "views/Prospects/customerCodeProspectLoader";

export default function ProspectsPage() {
    const { currentRoute } = useNavigation();
    const { routeType } = currentRoute;

    const isAddBusinessPage = routeType === 'ADD_BUSINESS';
    const isAddIndividualPage = routeType === 'ADD_INDIVIDUAL';
    const isCustomerCodePage = routeType === 'CUSTOMER_CODE';

    if (isCustomerCodePage) return <CustomerCodeProspectLoader/>;

    return <ProspectsPageWrapper isAddBusinessPage={isAddBusinessPage} isAddIndividualPage={isAddIndividualPage}/>;
}

function ProspectsPageWrapper({ isAddBusinessPage, isAddIndividualPage }) {
    // Le listing reste monté sous la fiche prospect : sans cette route, la recherche
    // partirait avec l'onglet de détail affiché par-dessus.
    const { activeListingRoute } = useFrontContext();
    const isProspectsAdd = isAddBusinessPage || isAddIndividualPage;
    const isListingShowing = !isProspectsAdd;

    const location = useLocation()
    const queryParameters = new URLSearchParams(location.search)
    const taskId = queryParameters.get('taskId') ?? null;
    useHashPulse(isListingShowing);

    return (
        <>
            <SearchProvider overrideRoute={activeListingRoute} searchRouteName={PROSPECT_SEARCH} pageType="prospects">
                <ToggleComponent isShowing={isListingShowing} className="page page-list">
                    <ProspectsListing/>
                </ToggleComponent>
            </SearchProvider>

            {isProspectsAdd && <ProspectsAdd type={isAddBusinessPage ? 'business' : 'individual'} taskId={taskId}/>}
        </>
    );
}
